<template>
	<div class="page-container">
		<md-dialog-alert
	      :md-active.sync="alert"
	      :md-content="msg"
	      md-confirm-text="Ok" />
		<md-app md-mode="fixed">
			<md-app-toolbar class="md-primary">
				<md-button class="md-icon-button" @click="backHome()">
					<md-icon>arrow_back</md-icon>
				</md-button>
				<span class="md-title" style="font-size: 15px; font-weight: bold;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 240px; margin-left: 0;">
					Pagamento via PIX
				</span>
			</md-app-toolbar>
			<md-app-content style="padding: 5px;padding-top: 0px;" class="p-2">
				<md-empty-state style="color: black;" class="no-event-found"
				md-icon="sentiment_very_dissatisfied" v-if="qrNotFound"
				:md-label="msg">
				<md-button class="md-raised md-accent" v-on:click="backHome()">
					VOLTAR
				</md-button>
				</md-empty-state>
				<div class="md-layout md-gutter md-alignment-center-center" v-if="loadingCob">
					<img class="titan-logo" src="../assets/loading.gif" style="width: 90px;">
				</div>
				<div v-if="!loadingCob && !qrNotFound" class="card">
					<div class="md-layout">
						<div class="md-layout-item logo">
							<img class="titan-logo" src="../assets/titan_logo.png">
						</div>
					</div>
					<div class="md-layout" v-if="!completeInfo">
						<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
							<div class="md-layout" style="padding: 0; ">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Pré-Aposta:</div>
											<div class="md-layout-item" style="font-weight: bold; text-align: center;font-size: 18px;">{{ payment.bet_id }}</div>
										</td>
										<td>
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Data:</div>
											<div class="md-layout-item" style="font-weight: bold; text-align: center;font-size: 17px;">{{ payment.bet_date }}</div>
										</td>
									</tr>
								</table>
							</div>
							<div class="md-layout" style="padding: 0; border-top: unset;">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Nome:</div>
											<div class="md-layout-item" style="font-weight: bold; text-align: center;font-size: 18px;">{{ payment.debtor_name }}</div>
										</td>
										<td>
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Telefone:</div>
											<div class="md-layout-item" style="font-weight: bold; text-align: center;font-size: 17px;">{{ payment.debtor_phone }}</div>
										</td>
									</tr>
								</table>
							</div>
							<div class="md-layout" style="padding: 0; border-top: unset;">
								<table style="width: 100%;">
									<tr>
										<td style="width: 50%;">
											<div class="md-layout-item md-size-100" style="font-size: 12px;">Valor:</div>
											<div class="md-layout-item" style="font-weight: bold; text-align: center;font-size: 17px;">{{ formataValor(payment.value) }}</div>
										</td>
										<td></td>
									</tr>
								</table>
							</div>
							<div class="md-layout" style="padding: 10px; margin-top: 10px; background-color: white; border-radius: 5px; color: #000000;">
								<blockquote>
									Para realizar o pagamento basta utilizar o <strong>PIX copia e cola</strong> clicando no campo ou apontar a câmera do celular para o <strong>QR Code</strong> que foi gerado logo abaixo.
									<div class="tabs is-centered">
										<ul>
											<li v-bind:class="tabActive(!show_qr_code)" v-on:click="toggleFormaPagamento()">
												<a>
													<span class="icon is-small"><i class="fas fa-image" aria-hidden="true"></i></span>
													<span>PIX Copia e Cola</span>
												</a>
											</li>
											<li v-bind:class="tabActive(show_qr_code)" v-on:click="toggleFormaPagamento()">
												<a>
													<span class="icon is-small"><i class="fa-solid fa-qrcode mr-2"></i></i></span>
													<span>QR Code</span>
												</a>
											</li>
										</ul>
									</div>
									<div class="columns is-centered" v-if="show_qr_code">
										<div class="column is-half">
											<qrcode-vue :value="payment.qrcode_text" :size="size" level="H" style="text-align: center; margin-top: 10px; margin-bottom: 10px;"></qrcode-vue>
										</div>
									</div>
									<div class="field mt-2" v-if="!show_qr_code">
										<p class="control has-icons-left has-icons-right"  @click="copyURL(qrcode_text)">
											<input class="input" type="text" v-model="qrcode_text" readonly>
											<span class="icon is-medium is-right">
												<i class="fa-solid fa-copy"></i>
											</span>
										</p>
									</div>
								</blockquote>
								<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
									<md-button class="md-raised md-primary" style="width: 95%;" @click="verificarPagamento()">JA PAGOU? CLIQUE AQUI PARA VERIFICAR!</md-button>
								</div>
							</div>
						</div>
					</div>
					<div class="md-layout" v-if="completeInfo">
						<div class="md-layout-item" style="padding-left: 10px; padding-right: 10px; margin-top: 10px;">
							<md-field>
						      <label>Apostador</label>
						      <md-input v-model="bet_punter"></md-input>
						    </md-field>
						    <div class="content p-2">
						    	<blockquote>ATENÇÃO! É o número de telefone que garante o recebimento em caso de prêmio, portanto atente-se para digitá-lo corretamente.</blockquote>
						    </div>
						    <md-field>
						      <label>Preencha seu telefone</label>
						      <md-input v-model="bet_punter_phone" type="phone" v-mask="'(##) #####-####'"></md-input>
						    </md-field>
						    <md-button class="md-raised md-primary" style="width: 95%;" @click="concluir()">CONCLUIR</md-button>
						</div>
					</div>
					<div class="content p-2" v-if="completeInfo" style="">
						<blockquote>
							Em caso de prêmio, utilize o número informado no campo acima e entre em contato através do nosso WhatsApp:  <br><span @click="solicitar()" style="font-size: 130%; color: black;">{{ suportePIX() }}</span></br>envie o número do seu bilhete e solicite o saque do seu prêmio.
						</blockquote>
					</div>
				</div>
			</md-app-content>
		</md-app>
	</div>
</template>
<script>

	import axios from 'axios'
	import QrcodeVue from 'qrcode.vue';

	export default {
		name: 'TitanPIXQRCode',
		components: {
			QrcodeVue
		},
		props: ['ticket'],
		data () {
			return {
				id: 0,
				loadingCob: true,
				qrNotFound: false,
				completeInfo: false,
				payment: [],
				size: 150,
				bet_punter: "",
				bet_punter_phone: "",
		        alert: false,
			    msg: "",
			    show_qr_code: false,
			    qrcode_text: "",
				timeOutFunction: undefined
			}
		},
        created() {
            this.id = this.$route.params.id;
        },
        methods: {
        	suportePIX: function(){
        		return this.$root.$data.SUPORTE_PIX;
        	},
        	solicitar: function() {
        		window.open("https://wa.me/55" + this.$root.$data.SUPORTE_PIX.match(  /\d+/g ).join("") + "?text=Gostaria%20de%20solicitar%20o%20saque%20de%20um%20premio!");
        	},
        	backHome: function() {
        		clearTimeout(this.timeOutFunction);
        		this.$router.push({ name: 'TitanTicket', params: { id: this.id }})
        	},
        	verifyOddEven: function(key) {
				return {
					'fundo-ticket-number-odd': (key % 2 == 0),
					'fundo-ticket-number-even': (key % 2 != 0)
				}
			},
        	verifyColorStatus: function(status) {
				return {
					'status-pendente-text': (status == 'Pendente'),
					'status-win-text': (status == 'Ganhou'),
					'status-lose-text': (status == 'Perdeu'),
					'status-canceled-text': (status == 'Cancelado'),
					'status-closed-text': (status == 'Encerrado')
				}
			},
	        concluir() {

	        	if (this.bet_punter == undefined || this.bet_punter == "" || this.bet_punter_phone == undefined || this.bet_punter_phone == "") {
	        		this.msg = "Apostador e telefone são obrigatórios.";
	        		this.alert = true;
					return false;
				}

	        	var jsonBet = {};
				jsonBet.bet_id = this.id;
				jsonBet.bet_punter = this.bet_punter;
				jsonBet.bet_punter_phone = this.bet_punter_phone;

				var form = new FormData();
				form.append("data", JSON.stringify(jsonBet));

				var config = {
				  headers: {'Content-Type': 'application/x-www-form-urlencoded'}
				};

				var v = this;
				axios.post(this.$root.$data.API_URL + 'update-bet-info', form, config)
				.then(function (response) {
			        //console.log(response);
		        	let result = response.data
					if (result.success) {
						window.location.reload()
					}
					else {
						v.msg = result.message
						v.alert = true
					}
				});

	        },
	        track() {
	        	var t = this
	        	t.verificarPagamento(false)
	        	t.timeOutFunction = setTimeout(function() {
	        		t.track()
	        	}, 5000);
	        },
	        verificarPagamento(msg = true) {
				if (this.id == 0) return false;

				if (msg) this.loadingCob = true;

	        	var config = {
				  headers: {}
				};

				axios
				.get(this.$root.$data.API_URL + 'confirm-pix-payment/' + this.id, config)
				.then(response => {
					if (response.data.success) {
		        		if (response.data.paid == true) {
		        			clearTimeout(this.timeOutFunction);
		        			this.$router.push({ name: 'TitanReprint', params: { id: this.id }})
		        		}
		        		else {
		        			if (msg) {
		        				this.msg = 'Infelizmente seu pagamento ainda não foi confirmado, aguarde uns instantes e tente novamente.';
								this.alert = true
							}
		        		}
		        	} else {
		        		this.msg = response.data.message + " Basta clicar no número a seguir <b><a href=\"https://wa.me/55" + this.$root.$data.SUPORTE_PIX.match(  /\d+/g ).join("") + "?text=Gostaria%20do%20reembolso%20da%20aposta%20"+ this.id + "%20pois%20o%20evento%20expirou!\">" + this.$root.$data.SUPORTE_PIX + "</a></b>."
						this.alert = true
		        	}
		        	this.loadingCob = false;
		        })
				.finally(() => this.loadingCob = false );
	        },
	        async copyURL(textToCopy) {
			    // navigator clipboard api needs a secure context (https)
			    if (navigator.clipboard && window.isSecureContext) {
			        // navigator clipboard api method'
			        await navigator.clipboard.writeText(textToCopy);

			        alert('Copiado!');
			    } else {
			        // text area method
			        let textArea = document.createElement("textarea");
			        textArea.value = textToCopy;
			        // make the textarea out of viewport
			        textArea.style.position = "fixed";
			        textArea.style.left = "-999999px";
			        textArea.style.top = "-999999px";
			        document.body.appendChild(textArea);
			        textArea.focus();
			        textArea.select();
			        return new Promise((res, rej) => {
			            // here the magic happens
			            document.execCommand('copy') ? res() : rej();
			            textArea.remove();

			            alert('Copiado!');
			        });
			    }
			},
			tabActive: function(valor) {
				return {
					'is-active': (valor == true)
				}
			},
			toggleFormaPagamento: function() {
				this.show_qr_code = !(this.show_qr_code);
			},
			formataValor: function(valor) {
				return parseFloat(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
			}
        },
        mounted() {

        	if (this.id == 0) return false;
        	if (!(this.$root.$data.PIX)) return false;

        	axios
			.get(this.$root.$data.API_URL + 'generate-pix-payment/' + this.id)
			.then(response => {
				if (response.data.success) {
	        		this.payment = response.data.payment
	        		this.qrcode_text = this.payment.qrcode_text;
	        		this.track();
	        	} else {
	        		if (response.data.message == "complete_info") {
	        			this.id = response.data.bet_id
	        			this.bet_punter = response.data.bet_punter
	        			this.completeInfo = true
	        		}
	        		else {
	    				this.qrNotFound = true
	    				this.msg = response.data.message
	        		}
	        	}
	        })
			.finally(() => this.loadingCob = false );
        }
	}
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine"; // Import the theme engine

@include md-register-theme("default", (
	primary: #000000, // The primary color of your brand
	accent: #CB1323 // The secondary color of your brand
	));

@import "~vue-material/dist/theme/all"; // Apply the theme

.logo {
	text-align: center;
	margin-top: 10px;
}

</style>


// WEBPACK FOOTER //
// src/components/TitanPIXQRCode.vue